module.exports = __webpack_public_path__ + "static/media/contacts.8d55cf0a.svg";